import { render, staticRenderFns } from "./danCiPinXie.vue?vue&type=template&id=3c2f3012&scoped=true&"
import script from "./danCiPinXie.vue?vue&type=script&lang=js&"
export * from "./danCiPinXie.vue?vue&type=script&lang=js&"
import style0 from "./danCiPinXie.vue?vue&type=style&index=0&id=3c2f3012&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c2f3012",
  null
  
)

export default component.exports